/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";

import NetworkProxyDetector from "./NetworkProxyDetector";
import NetworkProxy from "./networkProxy/NetworkProxy";
import FTPDFWebViewStreamReader from "./webViewReader/FTPDFWebViewStreamReader";
import LiquidModeView from "./views/LiquidModeView";
import NavigationSync from "./navigationSync/NavigationSync";
import Personalisation from "./Personalisation";

import useDxEventHandler from "./DxEventHandler";
import ErrorHandler from "./ErrorHandler";

const LiquidModeViewController = ({ shouldTriggerTranslation, liquidModeViewLoaded, ...props }) => {
  useDxEventHandler(liquidModeViewLoaded);
  return (
    <React.Fragment>
      <NetworkProxyDetector {...props} />
      {shouldTriggerTranslation && (
        <React.Fragment>
          <NetworkProxy {...props} />
          <FTPDFWebViewStreamReader {...props} />
          {liquidModeViewLoaded && <Personalisation {...props} />}
        </React.Fragment>
      )}
      <LiquidModeView {...props} />
      {liquidModeViewLoaded && <NavigationSync {...props} />}
      <ErrorHandler {...props} />
    </React.Fragment>
  );
};

export default LiquidModeViewController;
